module.exports = __webpack_public_path__ + "img/login.eec48ddc.gif";